import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { findPageTitle } from '@/app/routes/moduleRegistry'

/* ------------------------------------------------------------------
   عنوان تب مرورگر
   ------------------------------------------------------------------
   عنوان صفحه در index.html ایستا بود و هرگز عوض نمی‌شد: هر تبِ باز از
   این سامانه دقیقاً یک برچسب داشت. کاربری که «مرخصی‌ها» و «کارکنان» را
   کنار هم باز می‌کرد، در نوار تب‌ها هیچ راهی برای تشخیص‌شان نداشت — و
   در تاریخچه و نشانک‌ها هم همه یک اسم می‌گرفتند.

   🔴 منبعِ عنوان همان رجیستری است که آیکون و منو و مجوز از آن می‌آیند
   (بند ۵.۲). اگر هر صفحه عنوان خودش را می‌نوشت، دوباره ۳۳ نقطهٔ پراکنده
   داشتیم که با تغییر نام یک بخش از منو جدا می‌افتادند.

   ⚠️ نامِ سامانه همیشه در انتها می‌ماند: مرورگر تبِ باریک را از انتها
   می‌بُرد، پس چیزی که صفحه‌ها را از هم جدا می‌کند باید اول بیاید.
   ------------------------------------------------------------------ */

/*
 | نام برند — «کاربن».
 |
 | «پلتفرم یکپارچه سازمان» نامِ برند نیست، توضیحِ کارکرد است؛ همان
 | چیزی که در سایدبار و صفحهٔ ورود *زیرِ* کلمه‌نشان می‌نشیند و در
 | مانیفست مقدارِ `name` است. برند خودش در کلمه‌نشان می‌آید —
 | `alt` هر دو تصویر «کاربن» است.
 |
 | ⚠️ `short_name` مانیفست («پلتفرم یاسا») هم برند نیست: یاسا نامِ
 | سازمان است نه نامِ محصول. برای عنوان تب به کار نرود.
 |
 | تب همان سلسله‌مراتبِ سایدبار را نگه می‌دارد: اول برند، بعد
 | توضیح‌گر در نقشِ فرعی. توضیح‌گر داخل پرانتز می‌آید تا در تبِ
 | باریک که از انتها بریده می‌شود، آنچه حذف می‌شود توضیح باشد نه
 | نامِ برند.
 |
 | ⚠️ اگر برند عوض شد، manifest.webmanifest و index.html هم باید با
 | این یکی بمانند؛ آن دو ایستا هستند و از اینجا نمی‌خوانند.
 */
const APP_NAME = 'کاربن'

/** صفحه‌های خودِ Shell که ماژول نیستند و در رجیستری نمی‌آیند. */
const SHELL_TITLES: Record<string, string> = {
  '/login': 'ورود',
  '/app': 'داشبورد',
  '/app/inbox': 'کارتابل',
  '/app/notifications': 'اعلان‌ها',
  '/app/settings/notification-policy': 'تنظیم اعلان‌ها',
  '/app/profile/password': 'تغییر رمز عبور',
}

export function pageTitleFor(pathname: string): string {
  /* مسیر بدون اسلش انتهایی، تا `/app/inbox/` هم جور دربیاید. */
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname

  const title = SHELL_TITLES[path] ?? findPageTitle(path)

  return title ? `${title} — ${APP_NAME}` : APP_NAME
}

export function useDocumentTitle() {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = pageTitleFor(pathname)
  }, [pathname])
}
